<script>
import SideMenuGroup       from '../side-menu-group';
import ItemAccountEdit     from '../side-menu-item/account-edit';
import ItemPremiumRegister from '../side-menu-item/premium-register';
import SideMenuItemWallet  from '../side-menu-item/wallet';
import ItemLikeProducts from '../side-menu-item/like-products';
import ItemHaveProducts from '../side-menu-item/have-products';
import ItemPurchaseHistory from '../side-menu-item/purchase-history';

export default {
  name  : 'side-menu-group-atcosme',
  mixins: [SideMenuGroup],
  data  : function() {
    const menuItemsLogin = [
      SideMenuItemWallet,
      ItemPremiumRegister,
      ItemLikeProducts,
      ItemHaveProducts,
      ItemPurchaseHistory,
      ItemAccountEdit,
    ];
    const menuItemsLogout = [
      ItemPremiumRegister,
      ItemLikeProducts,
      ItemHaveProducts,
      ItemPurchaseHistory,
    ];
    return {
      // data内からcomputedを利用すべきではないので直接storeを参照
      menuItems      : this.$store.state.context.viewer.istyleId ? menuItemsLogin : menuItemsLogout,
      menuItemsLogout: menuItemsLogout,
      menuItemsLogin : menuItemsLogin,
      analytics      : { label: 'side_menu_group_atcosme' },
    };
  },
  computed: {
    viewerId: function() {
      return this.$store.state.context.viewer.istyleId;
    },
  },
  watch: {
    viewerId: function(viewerId) {
      this.menuItems = viewerId ? this.menuItemsLogin : this.menuItemsLogout;
    },
  },
};
</script>
